import { c as _c } from "react/compiler-runtime";
import { useTheme as useNextTheme } from "next-themes";
import { useIsClient } from "./use-is-client";
export function useTheme() {
  const $ = _c(8);
  const isMounted = useIsClient();
  const t0 = useNextTheme();
  let rest;
  let theme;
  if ($[0] !== t0) {
    ({
      theme,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = rest;
    $[2] = theme;
  } else {
    rest = $[1];
    theme = $[2];
  }
  const selectedTheme = isMounted ? theme ?? "system" : "system";
  let t1;
  if ($[3] !== isMounted || $[4] !== rest || $[5] !== selectedTheme || $[6] !== theme) {
    t1 = {
      isMounted,
      selectedTheme,
      theme,
      ...rest
    };
    $[3] = isMounted;
    $[4] = rest;
    $[5] = selectedTheme;
    $[6] = theme;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
}